<hs-content-condition-guard
  [guardedContent]="content"
  contentGuardCardHeader="No Account Loaded"
  contentGuardCardMessage="This panel requires an account to be loaded before information can be displayed.
      Load an account to continue."
  [conditionsMet$]="isSessionActiveWithAccounts$"
>
</hs-content-condition-guard>
